<template>
  <div class="h-full">

    <div class="bonus-table relative h-full">
      <div class="table-header h-[34px]">
        <div class="th">{{ t('vipRecompensas.vipLevel') }}</div>
        <div class="th">{{ t('vipRecompensas.recharge') }}</div>
        <div class="th">{{ t('vipRecompensas.bet') }}</div>
      </div>
      <div class="overflow-y-auto h-[calc(100%-34px)]">
        <div v-for="(row, idx) in maintenanceData" :key="row.level" :class="['table-row', { zebra: idx % 2 === 1 }]">
          <div class="td">{{ row.level }}</div>
          <div class="td">{{ numberFormat(row.recharge) }}</div>
          <div class="td">{{ numberFormat(row.bet) }}</div>
        </div>
      </div>

    </div>
  </div>
</template>
<script setup lang="ts">
import { numberFormat } from '@/utils/formatter'
import { useVipStore } from '@/stores/modules/vip'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const vipStore = useVipStore()
// 使用store中的保级数据
const maintenanceData = computed(() => vipStore.maintenanceData)
</script>

<style scoped>
.bonus-table {

  border-radius: 10px;
  overflow: hidden;

}

.table-header {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  text-align: center;
  padding-top: 5px;
  font-size: 10px;
  font-weight: bold;
  gap: 0;

  border-bottom: 1px solid #18805a;
}

.th {
  flex: 1;
  text-align: center;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #18805a;
}

.th:last-child {
  border-right: none;
}

.table-row {
  display: flex;
  font-size: 12px;
  color: #F7EA3C;
  align-items: center;
  height: 34px;
  border-bottom: 1px solid #18805a;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row .td {
  flex: 1;
  height: 34px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #18805a;
}

.table-row .td:last-child {
  border-right: none;
}

.table-row.zebra {
  background: rgba(64, 182, 101, 0.08);
}
</style>
